module.exports = new __parcel__URL__("icons8-javascript.d8eeb279.svg").toString();